import { Form, Checkbox } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { URL } from "../../00_Nav/url";

const LoginRemember = () => {
  const { t } = useTranslation("translation", { keyPrefix: "login" });
  // -------------------------- VAR --------------------------

  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item>
      <Form.Item name="remember" valuePropName="checked" noStyle>
        <Checkbox>{t("remember")}</Checkbox>
      </Form.Item>
      {/* <a className="login-form-forgot" href={URL.forgot}>
        {t("forgot")}
      </a> */}
    </Form.Item>
  );
};

export default LoginRemember;
